import { useEffect, useRef } from 'react';
import maplibregl, { NavigationControl } from 'maplibre-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';

/*
Reason for customizing mapbox draw

- Was getting error as below
Error: layers.gl-draw-lines.cold.paint.line-dasharray[2][0]: 
Expression name must be a string, but found number instead. 
If you wanted a literal array, use ["literal", [...]].

- This happens because MapLibre’s style spec is stricter than Mapbox GL, 
and newer versions of Mapbox GL Draw ship styles that use expressions MapLibre doesn’t fully accept.
*/
const getMapBoxDraw = () => {
  return new MapboxDraw({
    displayControlsDefault: true,
    defaultMode: 'simple_select',
    controls: {
      line_string: false,
      point: false,
      combine_features: false,
      uncombine_features: false,
      polygon: true,
      trash: true,
    },
    styles: [
      {
        id: 'gl-draw-polygon-fill',
        type: 'fill',
        filter: ['all', ['==', '$type', 'Polygon']],
        paint: {
          'fill-color': '#2563eb',
          'fill-opacity': 0.25,
        },
      },
      {
        id: 'gl-draw-polygon-stroke',
        type: 'line',
        filter: ['all', ['==', '$type', 'Polygon']],
        paint: {
          'line-color': '#2563eb',
          'line-width': 2,
        },
      },
      {
        id: 'gl-draw-lines',
        type: 'line',
        filter: ['all', ['==', '$type', 'LineString']],
        paint: {
          'line-color': '#2563eb',
          'line-width': 2,
          'line-dasharray': ['literal', [0.2, 2]],
        },
      },
      {
        id: 'gl-draw-points',
        type: 'circle',
        filter: ['all', ['==', '$type', 'Point']],
        paint: {
          'circle-radius': 5,
          'circle-color': '#2563eb',
        },
      },
    ],
  });
};

function ServiceDirectoryMap({
  lat = 0,
  lng = 0,
  zoom = 14,
  onReady = () => undefined,
  onMapBoxChange,
  ...props
}) {
  const mapContainer = useRef(null);
  const map = useRef(null);

  const viewportHeight = window.innerHeight;
  const mapHeight = viewportHeight - 70;

  useEffect(() => {
    if (map.current) return; // stops map from intializing more than once
    const mapUrl = `https://api.maptiler.com/maps/${
      process.env.REACT_APP_MAP_ID || 'streets'
    }/style.json?key=${process.env.REACT_APP_MAP_API_KEY}`;

    map.current = new maplibregl.Map({
      container: mapContainer.current,
      style: mapUrl,
      center: [lng, lat],
      zoom,
      attributionControl: true,
    });

    const mapboxDraw = getMapBoxDraw();

    map.current.on('load', async () => {
      onReady(map.current, mapboxDraw);
    });

    // map.current.addControl(mapboxDraw, 'top-right');
    map.current.addControl(new NavigationControl(), 'bottom-right');
  }, [lng, lat, zoom]);

  return (
    <div style={{ width: '100%', height: `${mapHeight}px` }} {...props}>
      <div ref={mapContainer} style={{ width: '100%', height: '100%' }}>
        &nbsp;
      </div>
    </div>
  );
}

export default ServiceDirectoryMap;
